<template>
  <div class="pagination_box">
    <div class="pagination_wrap">
      <ul class="clearfix">
        <!-- prev -->
        <li
          v-if="page > limitPageSize"
          class="first btn"
          :class="{ disabled: current === 1 }"
          @click="setCurrent(current - 1)"
        >
          <a>&lt;</a>
        </li>

        <!-- 页数列表 -->
        <li v-for="(item, index) in grouplist" :key="index">
          <a
          
            @click="setCurrent(item.val)"
            :class="{ active: current == item.val }"
            >{{ item.text }}</a
          >
        </li>

        <!-- next -->
        <li
          v-if="page > limitPageSize"
          class="last btn"
          :class="{ disabled: current === page }"
          @click="setCurrent(current + 1)"
        >
          <a>&gt;</a>
        </li>
      </ul>
      <div class="select-page" v-if="page > limitPageSize">
        <select @change="selectChange" :value="current">
          <option v-for="(item, index) in page" :key="index" :value="item">第{{ item }}页</option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "pagination",
  props: {
    // 当前页码
    currentPage: {
      type: Number,
      default: 1,
    },
    // 每页显示条数
    pagesize: {
      type: Number,
      default: 10,
    },
    // 总数
    total: {
      type: Number,
      default: 0,
    },
    // 分页条数
    pagegroup: {
      type: Number,
      default: 5,
      coerce: function (v) {
        v = v > 0 ? v : 5;
        return v % 2 === 1 ? v : v + 1;
      },
    },
  },
  data() {
    return {
      limitPageSize: 5
    };
  },
  computed: {
    /**
     * 返回当前页码
     */
    current() {
      return this.currentPage;
    },
    /**
     * 显示总页数
     */
    page() {
      return Math.ceil(this.total / this.pagesize);
    },
    /**
     * 获取分页页码
     */
    grouplist() {
      var len = this.page,
        temp = [],
        list = [],
        count = Math.floor(this.pagegroup / 2),
        center = this.current;
      if (len <= this.pagegroup) {
        while (len--) {
          temp.push({
            text: this.page - len,
            val: this.page - len,
          });
        }
        return temp;
      }
      while (len--) {
        temp.push(this.page - len);
      }
      var idx = temp.indexOf(center);
      idx < count && (center = center + count - idx);
      this.current > this.page - count && (center = this.page - count);
      temp = temp.splice(center - count - 1, this.pagegroup);
      do {
        var t = temp.shift();
        list.push({
          text: t,
          val: t,
        });
      } while (temp.length);
      if (this.page > this.pagegroup) {
        this.current > count + 1 &&
          list.unshift({
            text: "...",
            val: list[0].val - 1,
          });
        this.current < this.page - count &&
          list.push({
            text: "...",
            val: list[list.length - 1].val + 1,
          });
      }
      return list;
    },
  },
  methods: {
    /**
     * 设置当前页
     * @param {String} num  // 当前页数
     */
    setCurrent(num) {
      let idx = parseFloat(num);
      // 如果是点击当前页, 当前页面大于0, 小于总页数
      if (this.current !== idx && idx > 0 && idx < this.page + 1) {
        this.$emit("change", idx);
      }
    },
    selectChange(e) {
      const num = e.target.value;
      this.setCurrent(num);
    }
  },
};
</script>
<style lang="less" scope>
.pagination_box {
  width: 100%;

  .pagination_wrap {
    width: 100%;
    height: 33px;
    display: flex;
    align-items: center;
    justify-content: center;

    ul {
      display: flex;
      height: 100%;

      li {
        width: 33px;
        height: 33px;
        margin: 0 10px;

        a {
          display: block;
          width: 100%;
          height: 100%;
          background: #F4F4F4;
          border-radius: 2px;
          font-size: 16px;
          text-align: center;
          line-height: 33px;
          position: relative;
          color: #1B2841;
          text-decoration: none;
          cursor: pointer;

          &:hover,
          &.active {
            color: #ffffff;
            background: #06ae63;
          }
        }

        &.btn {
          a {
            height: 100%;

            &:hover {
              em {
                background: #06ae63;
              }
            }

            em {
              position: absolute;
              left: 50%;
              top: 50%;
              height: 6px;
              background: #000000;

              &:after {
                content: "";
                position: absolute;
                left: 50%;
                top: 50%;
                height: 6px;
                margin: -4px 0 0 -2px;
                background: #ffffff;
                transform: rotate(0deg);
              }
            }
          }
        }

        &.first {
          em {
            margin: -3px 0 0 -2px;
            transform: rotate(45deg);
          }
        }

        &.last {
          em {
            margin: -3px 0 0 -4px;
            transform: rotate(225deg);
          }
        }

        &.btn.disabled {
          em {
            background: #c1c6cd;
          }

          a {
            &:hover {
              color: #c1c6cd;
              border-color: transparent;

              em {
                background: #c1c6cd;
              }
            }
          }
        }
      }
    }

    .select-page {
      height: 100%;

      select {
        width: 108px;
        height: 33px;
        background: #FFFFFF;
        border-radius: 2px;
        border: 1px solid #E6E7EB;
        outline: none;
        text-align: center;

        option {
          width: 41px;
          height: 22px;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #1B2841;
          line-height: 22px;
        }
      }
    }
  }
}
</style>
